import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { MigrationTabType } from '../../my-bets-base/models/my-bets-viewmodels';

export class MyBetsTab {
    typeFilter: BetslipListType;
    selected = false;
    private countGetter: () => number;
    constructor(typeFilter: BetslipListType, countGetter: () => number) {
        this.typeFilter = typeFilter;
        this.countGetter = countGetter;
        this.selected = false;
    }

    get count(): number {
        return this.countGetter();
    }
}

export class MyBetsMigrationTab {
    typeFilter: MigrationTabType;
    selected = false;

    constructor(typeFilter: MigrationTabType) {
        this.typeFilter = typeFilter;
        this.selected = false;
    }
}
